import * as Headless from "@headlessui/react";
import React, { forwardRef, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

export interface LinkProps
  extends React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  children: ReactNode;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { children, href, ...restProps },
  ref
) {
  // Use React Router for internal links, regular anchor for external
  const isExternal = href?.startsWith('http') || href?.startsWith('mailto:') || href?.startsWith('tel:');

  if (isExternal || !href) {
    return (
      <Headless.DataInteractive>
        <a href={href} {...restProps} ref={ref}>
          {children}
        </a>
      </Headless.DataInteractive>
    );
  }

  return (
    <Headless.DataInteractive>
      <RouterLink to={href} {...restProps} ref={ref as React.Ref<HTMLAnchorElement>}>
        {children}
      </RouterLink>
    </Headless.DataInteractive>
  );
});
